import React, { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { UnenrolledPageComponent } from "./UnenrolledPage.component"
import { submitUnenrolledForm } from "../../actions/submitUnenrolledForm"
import { LGQuestionnaireStore } from "../../types/store.types"
import { ThankYouPage } from "../ThankYou"
import { ErrorPage } from "./UnenrolledPage.errorPage"
import { FormStatuses } from "@theguarantors/frontend-core/dist/types/formik"
import { statesMap, stateCodes } from "../../constants"
import { UnenrolledFormValues } from "./UnenrolledPage.types"
import { FormikHelpers } from "formik"
import { useUnenrolledRedirectHelper } from "../../feature-flags/useUnenrolledRedirectHelper"

const INVALID_STATE = "Invalid state"

const getStateCodeByName = (name: string): string => {
  return statesMap.get(name) || name
}

const isStateCode = (query: string): boolean => stateCodes.includes(query.toUpperCase())

const validateStateForSubmit = (name: string): string => (isStateCode(name) ? INVALID_STATE : getStateCodeByName(name))

export const UnenrolledPageContainer: React.FC = () => {
  useUnenrolledRedirectHelper()
  const dispatch = useDispatch()

  const formStatus = useSelector((state: LGQuestionnaireStore) => state.unenrolledForm.status)
  const errorMessage = useSelector((state: LGQuestionnaireStore) => state.unenrolledForm.error)
  const renterEmail = useSelector((state: LGQuestionnaireStore) => state.unenrolledForm.renterEmail)

  const submitForm = useCallback(
    async (
      { addressState, ...values }: UnenrolledFormValues,
      helpers: FormikHelpers<UnenrolledFormValues> | undefined
    ) => {
      if (!helpers) return
      const valuesWithStateCode = { ...values, addressState: validateStateForSubmit(addressState) }

      dispatch(submitUnenrolledForm(valuesWithStateCode, helpers))
      if (window && window.analytics) {
        window.analytics.track("Submitted Get Qualified Form", {})
      }
      window.scrollTo(0, 0)
    },
    [dispatch]
  )

  switch (formStatus) {
    case FormStatuses.success:
      return <ThankYouPage renterEmail={renterEmail} />
    case FormStatuses.error:
      return <ErrorPage errorMessage={errorMessage} />
    default:
      return <UnenrolledPageComponent onSubmit={submitForm} errorMessage={errorMessage} />
  }
}
